import { FormEvent, useState } from "react";
import { ApiError } from "../../api/client";
import { changeOwnPassword } from "../../api/users";
import { useAuth } from "../../auth/AuthContext";
import "./UserFormModal.css";

export function ChangeOwnPasswordModal(props: { onClose: () => void; forced?: boolean }) {
  const { onClose, forced = false } = props;
  const { updateUser } = useAuth();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  const policyOk =
    next.length >= 8 && /[A-Za-z]/.test(next) && /[0-9]/.test(next) && next !== current;

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (next !== confirm) {
      setError("Yeni parolalar eslesmiyor.");
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await changeOwnPassword(current, next);
      updateUser({ password_reset_required: false, last_password_change_at: new Date().toISOString() });
      setDone(true);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Parola degistirilemedi.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="kp-user-modal-backdrop" role="dialog" aria-modal="true">
      <div className="kp-user-modal">
        <header className="kp-user-modal__header">
          <h3>{forced ? "Parolanizi Degistirin" : "Şifremi Degistir"}</h3>
          {!forced && (
            <button className="kp-user-modal__close" onClick={onClose}>x</button>
          )}
        </header>
        {!done && (
          <form onSubmit={onSubmit} className="kp-user-modal__body">
            {forced && (
              <div
                style={{
                  background: "#fef3c7",
                  border: "1px solid #fcd34d",
                  color: "#92400e",
                  padding: "10px 12px",
                  borderRadius: 10,
                  fontSize: 13,
                  marginBottom: 4,
                }}
              >
                Guvenliginiz icin devam etmeden once parolanizi degistirmeniz gerekiyor.
              </div>
            )}
            <label className="kp-user-field">
              <span>Mevcut Parola <em>*</em></span>
              <input
                type="password"
                required
                value={current}
                disabled={busy}
                onChange={(e) => setCurrent(e.target.value)}
              />
            </label>
            <label className="kp-user-field">
              <span>Yeni Parola <em>*</em></span>
              <input
                type="password"
                minLength={8}
                maxLength={128}
                required
                value={next}
                disabled={busy}
                onChange={(e) => setNext(e.target.value)}
              />
              <small className="kp-muted">
                En az 8 karakter, en az 1 harf + 1 rakam. Eski parola ile ayni olamaz.
              </small>
            </label>
            <label className="kp-user-field">
              <span>Yeni Parola (Tekrar) <em>*</em></span>
              <input
                type="password"
                minLength={8}
                maxLength={128}
                required
                value={confirm}
                disabled={busy}
                onChange={(e) => setConfirm(e.target.value)}
              />
            </label>
            {error && <div className="kp-user-modal__error">{error}</div>}
            <div className="kp-user-modal__actions">
              {!forced && (
                <button type="button" className="kp-btn" onClick={onClose} disabled={busy}>
                  Vazgeç
                </button>
              )}
              <button
                type="submit"
                className="kp-btn kp-btn--primary"
                disabled={busy || !current || !policyOk || next !== confirm}
              >
                {busy ? "Kaydediliyor…" : "Degistir"}
              </button>
            </div>
          </form>
        )}
        {done && (
          <div className="kp-user-modal__body">
            <div
              style={{
                background: "#ecfdf5",
                border: "1px solid #a7f3d0",
                color: "#065f46",
                padding: "12px 14px",
                borderRadius: 10,
                fontSize: 13.5,
              }}
            >
              Parola Başarıyla Güncellendi.
            </div>
            <div className="kp-user-modal__actions">
              <button type="button" className="kp-btn kp-btn--primary" onClick={onClose}>
                Tamam
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
